import { render, staticRenderFns } from "./ElementGateway.vue?vue&type=template&id=2f3de3b8"
import script from "./ElementGateway.vue?vue&type=script&lang=js"
export * from "./ElementGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports